/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Pick_Target_StageInputs */

const cs_pipelines_pick_target_stage = /** @type {(inputs: Pipelines_Pick_Target_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout položky do fáze`)
};

const en_pipelines_pick_target_stage = /** @type {(inputs: Pipelines_Pick_Target_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move items to stage`)
};

/**
* | output |
* | --- |
* | "Move items to stage" |
*
* @param {Pipelines_Pick_Target_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_pick_target_stage = /** @type {((inputs?: Pipelines_Pick_Target_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Pick_Target_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_pick_target_stage(inputs)
	return cs_pipelines_pick_target_stage(inputs)
});